import { useAuthStore } from '../store';

/**
 * Returns permission flags for a given module based on the
 * Access Control role template loaded in the auth store.
 *
 * Usage:
 *   const { canCreate, canEdit, canDelete, canExport, canConfigure, canView } = usePermission('plans');
 *
 * Superadmin always gets true for everything.
 * If no role template has been loaded yet (e.g. network error), falls back
 * to the legacy role-based logic inside hasPermission().
 */
const usePermission = (module) => {
    const hasPermission = useAuthStore(s => s.hasPermission);
    const role          = useAuthStore(s => s.admin?.role);

    if (role === 'superadmin') {
        return {
            canView:      true,
            canCreate:    true,
            canEdit:      true,
            canDelete:    true,
            canExport:    true,
            canConfigure: true,
        };
    }

    return {
        canView:      hasPermission(module, 'view'),
        canCreate:    hasPermission(module, 'create'),
        canEdit:      hasPermission(module, 'edit'),
        canDelete:    hasPermission(module, 'delete'),
        canExport:    hasPermission(module, 'export'),
        canConfigure: hasPermission(module, 'configure'),
    };
};

export default usePermission;
